import type { TMessengerErpLayoutMode } from '@xometry/ui';
import { ESideOverlayType, type TSideOverlayContext } from 'stores/SideOverlay/SideOverlayStore';

import { getErpMessengerLayoutModeForMessengerPayload } from './getErpMessengerLayoutModeForPayload';

export interface GetMessengerLayoutForRenderingArgs {
  userPreference: TMessengerErpLayoutMode;
  isMobile: boolean;
  isEmbedded: boolean;
  overlayContext: TSideOverlayContext;
}

export const getMessengerLayoutForRendering = ({
  userPreference,
  isMobile,
  isEmbedded,
  overlayContext,
}: GetMessengerLayoutForRenderingArgs): TMessengerErpLayoutMode => {
  if (overlayContext.type !== ESideOverlayType.Messenger) return 'classic';

  if (overlayContext.messengerLayoutPresentation === 'forceClassic') return 'classic';

  return getErpMessengerLayoutModeForMessengerPayload({
    userPreference,
    isMobile,
    isEmbedded,
    payload: overlayContext,
  });
};
